<template>
  <div>
    
   <Header :background="`https://alkafeel.net/photos/imager/950967-964A4073.jpg/NzIw`"/>
   <Moharam  v-if="$store.state.options.moharam" />
    <div class="main-content" >
    
      
    <Gallery :navs=" [{
            title: 'الاحدث',
            category: 0,
            sort: 'add_desc'
          },
          {
            title: 'صور مختارة',
            category: 0,
            sort: 'random'
          },
          {
            title: 'العتبة الحسينية',
            category: '122',
            sort: 'add_desc'
          },
          {
            title: 'مناسبات دينية',
            category: '152',
            sort: 'add_desc'
          }
        ]"/> 
   </div>
   <div>
     <Footer/>
   </div>
   
  </div>
</template>
<script>
import Gallery from '../components/gallery.vue'
import Header from '../components/header.vue'
import Footer from '../components/footer.vue'
import Moharam from '../components/moharam.vue'

export default {
  data() {
    return {
      description:'sds'
    }
  },
  components:{
    Gallery,Header,Footer,Moharam
  },
  metaInfo() {
    return {
      title: "معرض الصور | العتبة الحسينية المقدسة",
      meta: [
        { vmid: "description", name: "description", content: this.description },
        {
          vmid: "og:title",
          property: "og:title",
          content: "Kanto | Pokémon Sprites"
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: "معرض الصور "
        },
        {
          vmid: "og:image:alt",
          property: "og:image:alt",
         content: "معرض الصور "
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: "https://pokemon-sprites.netlify.app/"
        },
        {
          vmid: "og:image",
          property: "og:image",
          content: `https://pic.imamhussain.org/photos/hd/110-7131653807421.jpg`
        }
      ]
    };
  },
}
</script>

 


